import memoize from 'memoizee';
import config from '@/constants/config';

const getHiddenPools = memoize(async () => {
    const hasFactoryRegistry = !!config.factoryV2RegistryAddress;
    if (!hasFactoryRegistry) return [];

    const { data: { [config.blockchainId]: hiddenPoolIds } } =
        await (await fetch('https://api.curve.finance/api/getHiddenPools')).json();

    return hiddenPoolIds || [];
}, {
    promise: true,
    maxAge: 30 * 60 * 1000, // 30m
});

export default getHiddenPools;
